module.exports = __webpack_public_path__ + "img/new18.ee2c291e.jpg";